<template>
  <div>
    <!-- Show the automatic install prompt if supported -->
    <InstallPrompt v-if="supportsAutomaticPrompt" />
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import InstallPrompt from './InstallPrompt.vue';

const supportsBeforeInstallPrompt = ref(false);

// Check if the beforeinstallprompt event is supported
onMounted(() => {
  console.log('[PWA] PWAInstallManager mounted');
  
  // Check if automatic installation is supported
  supportsBeforeInstallPrompt.value = 'BeforeInstallPromptEvent' in window;
  
  console.log('[PWA] Browser supports beforeinstallprompt:', supportsBeforeInstallPrompt.value);
});

// Computed properties for template
const supportsAutomaticPrompt = computed(() => supportsBeforeInstallPrompt.value);
</script>

<style scoped>
.pwa-debug {
  margin: 20px;
  padding: 15px;
  background-color: #f8f9fa;
  border: 1px dashed #999;
  border-radius: 8px;
  font-size: 14px;
}

.debug-button {
  background-color: #ff5722;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  margin-bottom: 10px;
  cursor: pointer;
}

.debug-info {
  background-color: white;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.debug-info ul {
  margin: 5px 0;
  padding-left: 20px;
}
</style>